// src/pages/Profile/ProfilePage.jsx
import React, { useEffect, useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { Link } from 'react-router-dom';
import '../../styles/profile/ProfilePage.css';

const ProfilePage = () => {
  const { currentUser, logout } = useAuth();
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setAnimate(true), 150);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="profile-page">
      <div className={`profile-container ${animate ? 'fade-in' : ''}`}>
        <h1 className="profile-title">My Account</h1>
        <p className="welcome-text">
          Welcome back, <span className="user-name">{currentUser?.email || 'User'}</span>
        </p>

        <div className="profile-grid">
          <Link to="/profile/orders" className="profile-card">
            <div className="icon-container">📦</div>
            <h3>Order History</h3>
            <p>View and track your past orders</p>
          </Link>

          <Link to="/profile/wishlist" className="profile-card">
            <div className="icon-container">❤️</div>
            <h3>Wishlist</h3>
            <p>Your saved books</p>
          </Link>

          <Link to="/profile/account-settings" className="profile-card">
            <div className="icon-container">⚙️</div>
            <h3>Account Settings</h3>
            <p>Update email, password, and preferences</p>
          </Link>
        </div>

        <button onClick={logout} className="logout-button">
          Logout
        </button>
      </div>
      <div className="background-dots"></div>
    </div>
  );
};

export default ProfilePage;
